import { reportAPI } from '@/services-ts/axios'
import type { IGetSurveyReport } from '@/types/Request'
import { defineStore } from 'pinia'

export const useSurveyReportStore = defineStore('surveyReport', {
  actions: {
    async GetSurveyReport(payload: IGetSurveyReport) {
      const { status, data } = await reportAPI.SurveyReportServices.GetSurveyReport(payload)
      return status ? data : null
    },

    async GetSurveyRepeatableReport(payload: IGetSurveyReport) {
      const { status, data } =
        await reportAPI.SurveyReportServices.GetSurveyRepeatableReport(payload)
      return status ? data : null
    },

    async GetSurveyReportExcel(payload: IGetSurveyReport) {
      await reportAPI.SurveyReportServices.GetSurveyReportExcel(payload)
    },

    async GetSurveyRepeatableReportExcel(payload: IGetSurveyReport) {
      await reportAPI.SurveyReportServices.GetSurveyRepeatableReportExcel(payload)
    },

    async GetSurveyAnswerByUserExcel(surveyId: string) {
      await reportAPI.SurveyReportServices.GetSurveyAnswerByUserExcel(surveyId)
    },
  },
})
